import {Injectable} from '@angular/core';
import {BaseResolverService} from '@abstract/base-resolver.service';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {RequestOptions} from '@abstract/api.service';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {RoutesStorage} from '@helpers/routes.helper';

/**
 * Получение списка параметров и структуры полей подписантов, для заполнения в форме
 * Структура полей зависит от НТД, на которую делается заключение, поэтому нужно
 * использовать в запросе elementId, чтобы backend смог вытащить НТД по элементу
 */

@Injectable()
export class ConclusionSignersStructureResolver extends BaseResolverService {
    protected redirectUrl = RoutesStorage.WorkingObject.list;

    constructor(
        service: TechnicalDeviceElementApiService,
        router: Router,
    ) {
        super(service, router);
    }

    getRequestParams(snapshot: ActivatedRouteSnapshot): RequestOptions {
        const service = this.resolverService as TechnicalDeviceElementApiService;
        const { elementId } = snapshot.parent.params;
        return {
            url: service.getSignersStructurePath(elementId)
        };
    }
}
